/** @format */

import React from 'react';
import { Grid, IconButton, Typography, Card, CardContent } from '@mui/material';
import { useStyles } from './style';
import NumberFormat from 'react-number-format';
import { ConfirmDialog, Icons, PriceLabel } from 'components';
import jMoment from 'moment-jalaali';
import Services from '../../services/DirectDebitServices';
import createToast from 'components/Toast/Toast';
import useCustomHook from './hooks';
import { useCurrencyUnit } from 'hooks';

export default function GrantItem({ data, wallets = [], refreshList }) {
  // --STATES--//
  const { isLoading, setIsLoading, openDialog, setOpenDialog } = useCustomHook();

  // --HOOKS--//
  const currencyText = useCurrencyUnit(false);

  const classes = useStyles();

  // --API--//

  const deleteGrant = async () => {
    if (!data?.id) return;
    try {
      setIsLoading(true);
      await Services.deleteWithdrawRule(data.id);
      setIsLoading(false);
      createToast('موفق', 'مجوز با موفقیت حذف شد', 'success');

      setOpenDialog(false);
      refreshList();
    } catch (err) {
      setIsLoading(false);
    }
  };

  // -- LOCAL VARIABLES --//

  // -- OTHER FUNCTIONS--//

  const getWalletName = () => {
    if (!wallets) return;
    const fWallet = wallets?.find((v) => v?.wallet === data?.wallet);
    return fWallet?.walletName ?? '';
  };

  return (
    <Card xs={12} className={classes.root}>
      <CardContent className={classes.content}>
        {/* Titles */}
        <Grid container justifyContent="space-between" alignItems="flex-start">
          <Grid item className={classes.titlePart}>
            <Typography variant="h5" className={classes.titleText}>
              حساب دیجیتال: {data?.wallet ? getWalletName() : '-'}
            </Typography>
            <Typography variant="h6" className={classes.subtitleText}>
              شناسه مجوز: {data?.id ?? '-'}
            </Typography>
          </Grid>
          <Grid item className={classes.titleActions}>
            <IconButton
              className={classes.actionsIcon}
              onClick={() => setOpenDialog(true)}
              size="large"
            >
              <Icons icon="Trash" color="#2b3990" size="20" />
            </IconButton>
          </Grid>
        </Grid>

        {/* Balances */}
        <Grid container justifyContent="space-between">
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>شماره حساب مبدا</Typography>
            <Typography className={classes.balanceMoney}>{data?.depositNumber ?? '-'}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>تاریخ ایجاد</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.creationDate
                ? jMoment(new Date(data.creationDate)).format('jYYYY/jMM/jDD')
                : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>حداقل موجودی حساب دیجیتال</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.onDemand && data?.minAmount != null ? (
                <>
                  <PriceLabel amount={data?.minAmount} currency={currencyText} />
                </>
              ) : (
                '-'
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>مبلغ برداشتی از حساب</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.maxAmount ? (
                <>
                  <PriceLabel amount={data?.maxAmount} currency={currencyText} />
                </>
              ) : (
                '-'
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>
              برداشت خودکار در صورت عدم موجودی
            </Typography>
            <Typography className={classes.balanceMoney}>
              {data?.onDemand ? 'فعال' : 'غیر فعال'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>نام کاربری حساب مبدا</Typography>
            <Typography className={classes.balanceMoney}>{data?.username ?? '-'}</Typography>
          </Grid>
        </Grid>
      </CardContent>
      <ConfirmDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={deleteGrant}
        title="تایید حذف مجوز برداشت"
        confirmButtonText="تایید و حذف مجوز"
        cancelButtonProps="انصراف"
        loading={isLoading}
        confirmButtonProps={{ type: 'submit' }}
      >
        آیااز حذف مجوز برداشت زیر اطمینان دارید؟
        <Typography style={{ marginTop: 10 }}>
          دیجیتال حساب: <b>{data?.wallet ? getWalletName() : '-'}</b>
        </Typography>
        <Typography>
          شناسه مجوز: <b>{data?.id ?? '-'}</b>
        </Typography>
        <Typography>
          شماره حساب مبدا: <b>{data?.depositNumber ?? '-'}</b>
        </Typography>
      </ConfirmDialog>
    </Card>
  );
}
